import { FC } from "react"
import { Button, IconButton, MenuItem, Rating, Select, Tooltip, Typography } from "@mui/material";


import categoria_prueba from '../../../assets/image/categoria_prueba.png';
import FavoriteBorderIcon from '@mui/icons-material/FavoriteBorder';
import CloseIcon from '@mui/icons-material/Close';

const recommended = [
    { id: 1, name: 'Frenos' },
    { id: 2, name: 'Llantas' },
    { id: 3, name: 'Ventanas' },
    { id: 4, name: 'Motor' },
    { id: 5, name: 'Parabrizas' },
]

const relevances = [
    { id: 1, name: 'Relevancia' },
    { id: 2, name: 'Mejor descuento' },
    { id: 3, name: 'Mayor precio' },
    { id: 4, name: 'Menor precio' }
]

interface RecomendedV3Props {
    relevanceSelected:any
    setShowModalProduct:React.Dispatch<React.SetStateAction<boolean>>
    handleCloseContent:() => void
}

export const RecommendedV3:FC<RecomendedV3Props> = (props) => {
    const { relevanceSelected, setShowModalProduct, handleCloseContent } = props

    return (
        <>
        <div style={{ width: '90%', display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between', marginTop: '20px', marginBottom: '15px' }}>
            <Select defaultValue={1} size="small" sx={{ borderRadius: '25px', width: '200px', height: '35px' }}>
                {relevances?.map((option) => (
                    <MenuItem key={option.id} value={option.id}>
                    {option.name}
                    </MenuItem>
                ))}
            </Select>
            <Tooltip title={'Cerrar panel'}>
                <IconButton onClick={() => handleCloseContent()}>
                    <CloseIcon fontSize='medium' style={{ color: '#91CBF9' }} />
                </IconButton>
            </Tooltip>
        </div>
        {
            recommended.map((category) => (
                <div key={category.id} style={{ maxWidth: '300px', margin: '2px', display: 'flex', flexDirection: 'row', padding: '5px', cursor: 'pointer' }}>
                    <div style={{ width: '40%', margin: '5px' }}>
                        <FavoriteBorderIcon fontSize='small' style={{ marginBottom: 'none' }} />
                        <img style={{ width: '100%' }} src={categoria_prueba} alt="" />
                    </div>
                    <div style={{ width: '60%' }}>
                        <Typography fontSize={'bigger'} fontWeight={'bold'}>{category.name}</Typography>
                        <div>
                            <Rating
                                name="star-rating"
                                value={3}
                                precision={0.5}
                                // onChange={handleRatingChange}
                                style={{ color: '#91CBF9' }}
                                readOnly
                            />
                        </div>
                        <Typography fontSize={'small'} style={{ textDecoration: 'line-through', color: '#9c9c9c' }}>S/ 959.00</Typography>
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                            <Typography fontSize={'bigger'} fontWeight={'bold'}>S/ 629.00</Typography>
                            <Typography fontSize={'11px'} style={{ backgroundColor: 'red', color: 'white', borderRadius: '0px 0px 0px 10px', padding: '2px', marginLeft: '5px' }}>-34%</Typography>
                        </div>
                        <div>
                            <Typography fontSize={'small'} fontWeight={'bold'}>Envío Gratis*</Typography>
                            <Typography fontSize={'9px'} fontWeight={'bold'}>+10% CON CUPÓN LLANT10</Typography>
                        </div>
                        <div style={{ width: '100%' }}>
                            <Button sx={{ border: '2px solid #D0D0D0', borderRadius: '20px', fontSize: '7px', color: '#707070', height: '25px', margin: '5px' }} onClick={() => setShowModalProduct(true)}>Ver más</Button>
                            <Button sx={{ borderRadius: '20px', fontSize: '7px', backgroundColor: '#91CBF9', color: '#fff', height: '25px' }}>Añadir al carrito</Button>
                        </div>
                    </div>
                </div>
            ))
        }
        </>
    )
} 